import React, { FC } from 'react';
import { useWatch } from 'react-hook-form';

import { SharePlanType } from '../../../../types/pool-plans.types';
import { AppFormattedMessage } from '../../../app-formatted-message/index';
import Button from '../../../button/index';
import { ChildrenFormProps } from './exercise-form.types';
import { FormSchema, stepOne as stepOneFormSchema } from './exercise-form.validation';
import { Bspce, StockOption, WarrantExercise } from './step-components/index';
import { Sar } from './step-components/sar/sar';

export type StepOneProps = ChildrenFormProps;

export const StepOne: FC<StepOneProps> = ({
  handleCloseModal,
  nextFormStep,
  control,
  setFormData,
  companyId,
  filedState,
  type,
  resetField,
}) => {
  const { stepOne } = useWatch<FormSchema>({ control });
  const { success } = stepOneFormSchema.safeParse(stepOne);

  const isValid = success && !filedState('stepOne').invalid;

  stepOne;

  if (!type) return;

  return (
    <>
      <div className="invisible-y-scroll flex max-h-[460px] w-full flex-col gap-2">
        {type === SharePlanType.STOCK_OPTIONS && (
          <StockOption
            companyId={companyId}
            control={control}
            resetField={resetField}
            setFormData={setFormData}
          />
        )}
        {/* {type === SharePlanType.RSA && (
          <Rsa
            companyId={companyId}
            control={control}
            resetField={resetField}
            setFormData={setFormData}
          />
        )} */}

        {type === SharePlanType.BSPCE && (
          <Bspce
            companyId={companyId}
            control={control}
            resetField={resetField}
            setFormData={setFormData}
          />
        )}
        {type === SharePlanType.WARRANTS && (
          <WarrantExercise
            companyId={companyId}
            control={control}
            resetField={resetField}
            setFormData={setFormData}
          />
        )}
        {type === SharePlanType.SAR && (
          <Sar
            companyId={companyId}
            control={control}
            resetField={resetField}
            setFormData={setFormData}
          />
        )}
      </div>

      <div className="flex h-[44px] w-full justify-between gap-3">
        <Button
          className="w-fit bg-transparent p-3 text-sm font-[450] text-gray-700"
          onClick={handleCloseModal}
          styleType="NONE"
          type="button"
        >
          <AppFormattedMessage id="CANCEL" />
        </Button>
        <div className="flex gap-3">
          <Button
            className="h-full w-[260px] p-3 text-sm font-[550] text-gray-25"
            data-permission-required
            disabled={!isValid}
            onClick={nextFormStep}
            type="button"
          >
            <AppFormattedMessage id="NEXT" />
          </Button>
        </div>
      </div>
    </>
  );
};
